import { Typography } from 'antd'
import { useState } from 'react'
import './customInput.css'

const CustomInput = (props) => {
    const { value = '', disabled = false, register = () => null, error = null, type = 'text', name = "name", label = '', onChange, required = false, width = '320px', minWidth = '', borderColor = '#cbcbcb' } = props

    return (
        <div className='flex-ver' >
            <label className="pure-material-textfield-outlined" style={{ width: `${width}`, height: 56, minWidth: minWidth }}>
                <input
                    {...register(name)}
                    value={value}
                    // value={value ? value : ''}
                    disabled={disabled}
                    type={type}
                    name={name}
                    style={{ borderColor: `${borderColor}` }}
                    placeholder=" "
                    onChange={onChange}
                ></input>
                <span>{label}
                    {required && <span className='star'>*</span>}
                </span>
            </label>
            {error?.[name] && <Typography.Paragraph style={{ color: 'red', fontWeight: 500 }} >{error?.[name]?.message} </Typography.Paragraph>}

        </div>
    )
}

export default CustomInput